<template>
    <div class="file-preview">
        <div class="file-preview-footer text-right">
            <button type="button" class="btn btn-danger" @click="close">{{translate('close')}}</button>
        </div>
        <div class="file-preview-content">
            <div class="container" style="margin-top: 20px;">
                <div>
                    <div v-if="!data" class="text-center" style="padding:100px;">
                        <spinner/> {{translate('processingMessages.remLoading')}}
                    </div>
                    <template v-else>
                        <div class="roundbox" style="overflow:hidden;">
                            <div class="rbcontent head">
                                <div>
                                    <h2>{{data.Subject}}</h2>
                                    
                                    <table style="margin-top:16px;" class="table table-borderless table-sm ozet">
                                        <tbody>
                                            <tr>
                                                <td>{{translate('remPreview.sender')}}</td>
                                                <td>:</td>
                                                <td><b>{{data.From.Address}}</b> <span style="margin-left:16px;">{{data.From.Name}}</span></td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('remPreview.receiver')}}</td>
                                                <td>:</td>
                                                <td>
                                                    <div v-for="t in data.To" :key="t.Address">{{t.Address}}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('remPreview.date')}}</td>
                                                <td>:</td>
                                                <td>{{data.Date | datetime}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{translate('remPreview.messageType')}}</td>
                                                <td>:</td>
                                                <td>{{data.IletiTip}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <small class="text-muted rembox-body">
                                        <div v-if="data.IsBodyHtml" v-html="data.Body"></div>
                                        <div v-else>{{data.Body}}</div>
                                    </small>
                                </div>
                            </div>
                            <div class="rbcontent">
                                <b>{{translate('draftEyp.attachments')}}</b>
                            </div>
                            <div class="table-container">
                                <table class="table table-borderless table-hover table-sm">
                                    <tbody v-if="data.AttachedMimeMessage">
                                        <tr v-for="d in data.AttachedMimeMessage.Attachments" :key="d.id" >
                                            <td>
                                                <file-download-link  :isActive="!data.isArchived" :isOnlineView="onlineViewEnabled" :document="d" @download="downloadAttachment" @preview="showFilePreview"></file-download-link>
                                            </td>
                                            <td class="text-muted text-right" style="white-space:pre">{{d.Size | prettyBytes}}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr v-for="d in data.Attachments" :key="d.id" >
                                            <td>
                                                <a href="#void" @click="downloadAttachment(d)">{{d.FileName}}</a>
                                            </td>
                                            <td class="text-muted text-right" style="white-space:pre">{{d.Size | prettyBytes}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="rbcontent form rembox-body" v-if="data.AttachedMimeMessage">
                                <div v-if="data.AttachedMimeMessage.IsBodyHtml" v-html="data.AttachedMimeMessage.Body"></div>
                                <div v-else>{{data.AttachedMimeMessage.Body}}</div>
                            </div>

                        </div>
                    </template> 
                </div>
            </div>
            <file-preview v-if="fileDetail" :file="fileDetail" :isOnlineView="onlineViewEnabled" :viewer="viewerType" @close="fileDetail=null;"></file-preview>
        </div>
        <!-- <div class="file-preview-footer text-right">
            <button type="button" class="btn btn-primary" @click="close">Kapat</button>
        </div> -->

    </div>
</template>

<script>
import formMixin from '../formMixin.js';
import axios from 'axios';
import spinner from '@/components/Spinner.vue'
import fileDownloadLink from '../components/FileDownloadLink.vue'
import filePreview from '../components/FilePreview.vue';

export default {
    mixins: [formMixin],
    components: {
        spinner,
        fileDownloadLink,
        filePreview
    },
    
    created(){
        this.getOnlineViewPermission()
        .then(x => {
            this.onlineViewEnabled = x;
        }).catch(x => {
            console.warn("getOnlineViewPermission alınamadı:", x);
            this.onlineViewEnabled = true;
        });
       this.getParsedRem(this.$route.params.id)
    },
    data() {
        return {
            loading: false,
            data: null,
            fileDetail: null,
            onlineViewEnabled: true
        }
    },
    methods: {
        downloadAttachment(attachment, menuKey){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/incomingDoc/createAttachmentUrl/`, {
                  EntityId : this.data.Id,
                  DocumentId: attachment.Id,
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url + (menuKey == 'view' ? "&view=true" : ""));
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        showFilePreview(document, type) {
            this.fileDetail = document;
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            this.fileDetail.EntityType = "IncomingDoc"
        },
        close(){
            this.$emit('close');
        },
        async getParsedRem(id){
            this.loading = true;
            var url = `/incomingDoc/ParseRem/${id}`;
            return axios
              .get(url)
              .then(x => {
                console.log("POST Result:", x.data);
                this.data = x.data;
                this.loading = false;
              })
              .catch(x => {
                   window.processErrorResponse(x, this);
                   this.$router.go(-1);
               });
        }
    }
}
</script>
<style scoped>

.file-preview {
        position:fixed;
        top:58px;
        right:0;
        bottom:0;
        left:0;
        background:#FFF;
    }

    .file-preview-content {
        position:fixed;
        top:58px;
        right: 0;
        bottom: 55px;
        left: 0;
        overflow: auto;
        padding: 30px 0;
    }

    .file-preview-footer {
        z-index: 999;
        position: fixed;
        right:0;
        left:0;
        padding: 8px;
        margin-right: 15px;
    }

    .iframe {
        position: fixed;
        left: 0;
        right: 0;
        width: 100%;
        top: 59px;
        bottom: 50px;
        height: calc(100% - 113px);
    }

</style>